import publisherAPIInstance from "./publisherApiInstance";

const webhookAPIs = {
  createWebhook: ({ payload }) => publisherAPIInstance.post(`/api/v1/webhook.create`, payload),
  listWebhook: ({ payload }) => publisherAPIInstance.post(`/api/v1/webhook.list`, payload),
  deleteWebhook: ({ payload }) => publisherAPIInstance.post(`/api/v1/webhook.delete`, payload),
};

export default webhookAPIs;
